<div [ngClass]="cssClassName" class="table-container">
  <div class="table-wrapper" [class.loading-wrapper]="isLoadingResults">
    @if (isLoadingResults) {
      <div class="loading-overlay" data-testid="results-loading-indicator">
        <mat-spinner diameter="36"></mat-spinner>
        <span>{{ loadingResultsLabel }}</span>
      </div>
    }
    @if (dataSource.data?.length && showConfigButton) {
      <div class="config-button-container">
        <mat-icon (click)="openColumnConfigDialog()" matTooltip="Configure columns"
                  i18n-matTooltip="@@resultList.configureColumns">settings
        </mat-icon>
      </div>
    }
    @if (dataSource.data?.length) {
      <table mat-table [dataSource]="dataSource"
        [multiTemplateDataRows]="true" [class.loading]="isLoadingResults">
        @for (col of columnsToDisplay; track trackByColumnId($index, col)) {
          @if (col.lang?.length) {
            @if (col.isTermName) {
              <ng-container [matColumnDef]="col.columnId!">
                <th mat-header-cell *matHeaderCellDef>{{ col.header }}</th>
                <td class="term-name-container" mat-cell *matCellDef="let res">
                  <pub-term-render [term]="getTerm(res, col)"></pub-term-render>
                </td>
              </ng-container>
            }
            @if (!col.isTermName) {
              <ng-container [matColumnDef]="col.columnId!">
                <th mat-header-cell *matHeaderCellDef>{{ col.header }}</th>
                <td mat-cell *matCellDef="let res">
                  <div pub-field-render [field]="res | getDisplayField:col" (conceptSelected)="selectConcept($event)"></div>
                </td>
              </ng-container>
            }
          }
          @if (!col.lang?.length) {
            <ng-container [matColumnDef]="col.columnId!">
              <th mat-header-cell *matHeaderCellDef>{{ col.header }}</th>
              <td mat-cell *matCellDef="let res;">
                <div pub-field-render [field]="res | getDisplayField:col" (conceptSelected)="selectConcept($event)"></div>
              </td>
            </ng-container>
          }
        }
        <ng-container matColumnDef="expand">
          <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
          <td mat-cell *matCellDef="let res">
            <button mat-icon-button [disabled]="isLoadingResults">
              <mat-icon>keyboard_arrow_{{ expandedRes === res ? 'up' : 'down' }}</mat-icon>
            </button>
          </td>
        </ng-container>
        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let res" [attr.colspan]="columnIDsToDisplay.length">
            <div class="elem-detail" [@detailExpand]="res === expandedRes ? 'expanded' : 'collapsed'">
              @if (res !== expandedRes) {
              } @else {
                <pub-result-view-wrapper (conceptSelected)="selectConcept($event)"></pub-result-view-wrapper>
              }
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnIDsToDisplay"></tr>
        <tr mat-row *matRowDef="let res; columns: columnIDsToDisplay;" class="elem-row"
          [class.loading-row]="isLoadingResults"
          (click)="!isLoadingResults && resultClick(res)" [twTippy]="getRowTooltip(res)" twTippyPlacement="bottom-start"
          [twTippyDisable]="!showTooltips || isLoadingResults">
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
        </table>
      }
      @if (dataSource.data?.length && resultPaginator) {
        <mat-paginator [length]="resultPaginator.totalItems"
          [pageSize]="resultPaginator.pageSize"
          [pageIndex]="resultPaginator.pageIndex"
        (page)="pageChange($event)" [showFirstLastButtons]="true"></mat-paginator>
      }
    </div>
    @if (hasNoResults()) {
      <div data-testid="no-results-message">{{ noResultsLabel }}@if (getSearchTerm()?.length) {
        <span
        > {{ noResultsForLabel }} "{{ getSearchTerm() }}"</span>
      }</div>
    }
  </div>
